import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, forwardRef } from '@angular/core';
import { CustomHttpInterceptor } from 'angular/resources/request.service';

@NgModule({
    imports: [HttpClientModule],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: forwardRef(() => CustomHttpInterceptor),
            multi: true
        }
    ]
})
export class RestResourceModule {}
